const valuesFor = (filters, key) => filters?.find((filter) => filter.key === key)?.values;

const passCount = (entry) => ({ value: entry.value, text: entry.text, count: entry.count ?? 0 });

export const buildGroupFilterCategory = (filters, showCounts) => {
    const category = { key: 'group_id', title: 'Group', showCounts };
    const groupValues = valuesFor(filters, 'group_id');
    category.customValues = groupValues ? groupValues.map(passCount) : undefined;
    return category;
};

export const groupIdFromActiveFilters = (activeFilters) => {
    if (!activeFilters) {
        return undefined;
    }
    return activeFilters.group_id;
};
